/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-console */
import React, { useState } from 'react';
import Layout from 'antd/lib/layout/layout';
import { useFormik, FormikProvider, Form } from 'formik';
import {
  Spin,
  Select,
} from 'antd';
import isEqual from 'lodash.isequal';
import PageTitle from '../../lib/page-title';
import useGetCreateGroupTypeData from './use-getCreateGroupTypeData';
import FormControl from '../../lib/form-control';
import PrimaryButton from '../../lib/primary-button';
import { ReactComponent as GroupTypeIcon1 } from '../../../assets/icons/groupType1.svg';
import { ReactComponent as GroupTypeIcon2 } from '../../../assets/icons/groupType2.svg';
import { ReactComponent as GroupTypeIcon3 } from '../../../assets/icons/groupType3.svg';
import { ReactComponent as GroupTypeIcon4 } from '../../../assets/icons/groupType4.svg';
import { ReactComponent as GroupTypeIcon5 } from '../../../assets/icons/groupType5.svg';
import { ReactComponent as GroupTypeIcon6 } from '../../../assets/icons/groupType6.svg';

import './create-group-type.less';
import { createValidator } from '../../../utils/create-validator';
import { CreateGroupTypeDTO } from '../../../store/modules/facility/dto/create-group-type.dto';
import { EditGroupTypeDTO } from '../../../store/modules/facility/dto/edit-group-type.dto';
import DeleteModal from '../../lib/delete-modal';
import LeavePageModal from '../../lib/leave-page-modal';
import checkPermission from '../../../utils/permissions/permissions';
import PermissionProvider from '../../providers/permissionProvider';

export const icons = {
  icon1: {
    icon: GroupTypeIcon1,
    name: 'icon1',
  },
  icon2: {
    icon: GroupTypeIcon2,
    name: 'icon2',
  },
  icon3: {
    icon: GroupTypeIcon3,
    name: 'icon3',
  },
  icon4: {
    icon: GroupTypeIcon4,
    name: 'icon4',
  },
  icon5: {
    icon: GroupTypeIcon5,
    name: 'icon5',
  },
  icon6: {
    icon: GroupTypeIcon6,
    name: 'icon6',
  },
};

const CreateGroupType = () : JSX.Element => {
  const {
    initialValues,
    loading,
    onSubmit,
    title,
    isEdit,
    onDelete,
  } = useGetCreateGroupTypeData();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const formik = useFormik({
    initialValues,
    onSubmit,
    enableReinitialize: true,
    validate: (values) => {
      if (isEdit) {
        return createValidator(EditGroupTypeDTO, values);
      }
      return createValidator(CreateGroupTypeDTO, values);
    },
  });

  const {
    values,
    setFieldValue,
    isSubmitting,
  } = formik;

  const formHasChanged = !isEqual(initialValues, values);
  const hasNotWritePermission = !checkPermission('organization', 'write');
  return (
    <Layout className="main-container">
      <PermissionProvider pageId="organization">
        {formHasChanged && !isSubmitting && <LeavePageModal /> }
        <DeleteModal
          text={title}
          modalVisible={deleteModalVisible}
          onConfirm={() => {
            onDelete();
            setDeleteModalVisible(false);
          }}
          onCancel={() => setDeleteModalVisible(false)}
        />
        <PageTitle back title={title}>
          {isEdit && <PrimaryButton disabled={hasNotWritePermission} title="Delete Group" onClick={() => setDeleteModalVisible(true)} />}
        </PageTitle>
        {loading ? <Spin size="large" /> : (
          <FormikProvider value={formik}>
            <Form className="formik-form">
              <div className="name-input">
                <FormControl inputClassName="formik-form__input" name="name" label="Name" type="text" disabled={hasNotWritePermission} />
              </div>
              <div className="form__wrapper ant-col ant-form-item-label group__label">
                <p className="group__label">Icon</p>
                <Select
                  disabled={hasNotWritePermission}
                  size="large"
                  className="ant__select formik-form__dropdown"
                  value={values.icon || icons.icon1.name}
                  defaultValue={values.icon || icons.icon1.name}
                  onChange={(icon) => {
                    setFieldValue('icon', icon);
                  }}
                >
                  { Object.values(icons).map((icon, _) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Select.Option key={`${icon.name},${_}`} value={icon.name}>
                      <icon.icon className="groupType-card__img" />
                    </Select.Option>

                  ))}
                </Select>
              </div>
              <PrimaryButton type="submit" disabled={!formHasChanged || hasNotWritePermission} className="asset-form__submit" title="Save" />
            </Form>
          </FormikProvider>
        )}
      </PermissionProvider>
    </Layout>
  );
};

CreateGroupType.displayName = 'CreateGroupType';

export default CreateGroupType;
